import React, { useEffect } from 'react';
import { useTenant } from '../contexts/TenantContext';

/**
 * Applica variabili CSS globali basate sui colori del tenant.
 */
const TenantThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { tenantInfo } = useTenant();

    useEffect(() => {
        const root = document.documentElement;
        if (tenantInfo) {
            const primary = (tenantInfo as any).primaryColor || tenantInfo.colori?.primario || '#2196f3';
            const secondary = (tenantInfo as any).secondaryColor || tenantInfo.colori?.secondario || '#f50057';
            const bg = (tenantInfo as any).backgroundColor || tenantInfo.colori?.sfondo || '#ffffff';
            const text = (tenantInfo as any).textColor || tenantInfo.colori?.testo || '#222222';
            root.style.setProperty('--tenant-primary', primary);
            root.style.setProperty('--tenant-secondary', secondary);
            root.style.setProperty('--tenant-bg', bg);
            root.style.setProperty('--tenant-text', text);
            if ((tenantInfo as any).fontFamily) {
                root.style.setProperty('--tenant-font', (tenantInfo as any).fontFamily);
            }
            root.setAttribute('data-tenant-ready', 'true');
        } else {
            root.removeAttribute('data-tenant-ready');
        }
    }, [tenantInfo]);

    return <>{children}</>;
};

export const useTenantBrandReady = () => {
    const { tenantInfo } = useTenant();
    return !!tenantInfo;
};

export default TenantThemeProvider;
